import * as Cookies from '../components/Cookies';
import * as Preloader from '../components/Preloader';
import * as MainHeader from '../components/MainHeader';
import * as Homepage from '../components/Homepage';
import * as PostSingle from '../components/PostSingle';
import * as IssueSingle from '../components/IssueSingle';
import * as MainFooter from '../components/MainFooter';
import * as Newsletter from "../components/Newsletter";
import * as FreeDigitalCopy from "../components/FreeDigitalCopy";
import * as VideoBanner from "../components/VideoBanner";

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    Cookies.init();
    Preloader.init();
    MainHeader.init();
    Homepage.init();
    PostSingle.init();
    IssueSingle.init();
    MainFooter.init();
    Newsletter.init();
    FreeDigitalCopy.init();
    VideoBanner.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js